import React, { useRef, useEffect } from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import classNames from 'classnames'

// Event color presets
export const eventColors = {
    red: {
        bg: 'bg-red-custom',
        text: 'text-red-custom',
        dot: 'dot-red-custom',
    },
    green: {
        bg: 'bg-green-custom',
        text: 'text-green-custom',
        dot: 'dot-green-custom',
    },
    blue: {
        bg: 'bg-blue-custom',
        text: 'text-blue-custom',
        dot: 'dot-blue-custom',
    },
}

const CalendarView = ({
    wrapperClass,
    toolbarButtons = true,
    calCurrDate,
    initialView = 'timeGridDay',
    events = [],
    datesSet, // 👈 accept datesSet as prop
    ...rest
}) => {
    const calendarRef = useRef(null);

    useEffect(() => {
        if (calendarRef.current && calCurrDate) {
            calendarRef.current.getApi().gotoDate(calCurrDate);
        }
    }, [calCurrDate]);

    const renderEventContent = (arg) => {
        const { event } = arg;
        const { extendedProps,_id } = event;
        const isStart = arg.isStart;
        const isEnd = arg.isEnd;

        const colorTheme = eventColors[extendedProps?.eventColor] || {
            bg: 'bg-red-custom',
            text: 'text-red-custom',
            dot: 'dot-red-custom',
        };

        console.log('colorTheme', colorTheme, event);

        return (
            <div
            className={classNames(
              'calendar-event p-1 rounded w-100 d-flex flex-wrap align-items-start gap-1',
              colorTheme.bg,
              colorTheme.text,
              isEnd && !isStart && 'no-left-radius',
              isStart && !isEnd && 'no-right-radius'
            )}
          >
            {!(isEnd && !isStart) && (
              <span className="time-text me-1">{arg.timeText} </span>
            )}
            <strong className="time-title">
              {event.title}
              {extendedProps?.clientName && ` - ${extendedProps.clientName}`}
            </strong>
          </div>
          
        );
    };

    return (
        <FullCalendar
            ref={calendarRef}
            initialView={initialView}
            events={events}
            headerToolbar={{
                left: 'title',
                center: '',
                right: toolbarButtons
                    ? 'timeGridDay,timeGridWeek,dayGridMonth, prev,next'
                    : '',
            }}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            slotMinTime="08:00:00"
            slotMaxTime="20:30:00"
            eventContent={renderEventContent}
            datesSet={datesSet} 
            {...rest}
        />
    );
};


export default CalendarView
